const initialState = {
  isData: false,
  lugar: [],
  selLugar: null,
  pagination: null,
};

const initialLugarState = {
  selLugar: null,
};

export const lugar = (state = initialState, action) => {
  switch (action.type) {
    case 'setLugar': {
      if (action.value.status === 200) {
        const stateData = {
          lugar: action.value.data,
          isData: true,
          pagination: action.value.pagination,
        };
        return { ...state, ...stateData };
      } else {
        return initialState;
      }
    }
    case 'setLugarInit': {
      return initialState;
    }
    case 'setSelLugar': {
      const obj = {
        ...action.value,
      };

      const stateData = { selLugar: obj };

      return { ...state, ...stateData };
    }
    case 'setSelLugarInit': {
      return { ...state, ...initialLugarState };
    }

    default:
      return state;
  }
};
